export const POLICY_DESPOTISM_UNIT_DISCOUNT_D6 = 1;
export const POLICY_DESPOTISM_UNIT_DISCOUNT_D10 = 2;
export const POLICY_DESPOTISM_UNIT_DISCOUNT_D20 = 3;
export const POLICY_DESPOTISM_UNIT_DISCOUNT_D8 = 2;
export const POLICY_DESPOTISM_UNIT_DISCOUNT_D12 = 2;

export const POLICY_DESPOTISM_BUILDING_DISCOUNT_MILITARY_CAMP = 4;
